import { render, staticRenderFns } from "./PreviewMaker.vue?vue&type=template&id=530970a8&"
import script from "./PreviewMaker.vue?vue&type=script&lang=js&"
export * from "./PreviewMaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports